import PropTypes from 'prop-types';

const MessagePropTypes = {
    tagName: PropTypes.string
};

const DialogueProductPropTypes = {
    renderProductDisclosuresFn: PropTypes.func,
    renderProductFeaturesFn: PropTypes.func,
    productDetailsAndDisclosuresRender: PropTypes.node,
    productActionsRender: PropTypes.node,
    description: PropTypes.any,
    name: PropTypes.any,
    productClassNames: PropTypes.string.isRequired,
    productUrl: PropTypes.any,
    product: PropTypes.any,
    cartButtonRender: PropTypes.any
};

export {
    DialogueProductPropTypes,
    MessagePropTypes
}
